
import Vuex from "vuex"
import News from "./news"
import Navigation from "./navigation"


export default new Vuex.Store({
  state: {
    defaultError:
      "Please reload/refresh, an error was detected. Contact comitmobileteam@vbgov.com if it still occurs.",
    errorMessage:
      "Please reload/refresh, an error was detected. Contact comitmobileteam@vbgov.com if it still occurs.",
    deviceInfo: undefined,
  },

  modules: {
    news: News,
    navigation: Navigation,
  },

})
